<template>
    <!-- Zoom In/Out Menu-->
    <div class="flex flex-row items-center justify-center gap-2 w-full p-1"
        :class="[props.theme]">
        <button @click="zoomIn()" 
            class="size-10 p-2 hover:bg-gray-200 rounded-md border border-gray-200 dark:border-transparent dark:text-white dark:hover:bg-gray-600"
            :class="{'border-transparent text-white bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600':  zoomConfig>DEFAULT_ZOOM_VALUE}">
            <MagnifyingGlassPlusIcon class="w-6 h-6" />
        </button>
        <button @click="zoomOut()" 
            class="size-10 p-2 hover:bg-gray-200  rounded-md border border-gray-200 dark:border-transparent dark:text-white dark:hover:bg-gray-600"
            :class="{'text-white bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600':  zoomConfig<DEFAULT_ZOOM_VALUE}"
            >
            <MagnifyingGlassMinusIcon class="w-6 h-6" />
        </button>
    </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, onMounted, watch } from 'vue'
import { MagnifyingGlassMinusIcon, MagnifyingGlassPlusIcon } from '@heroicons/vue/24/outline'
import {appEvents} from '@/store/app.events'
import zoomStore from '@/store/zoom.store'

const DEFAULT_ZOOM_VALUE = 1;
const MIN_ZOOM_VALUE = 0.5;
const MAX_ZOOM_VALUE = 2;
const zoomConfig = ref(DEFAULT_ZOOM_VALUE)
const emit = defineEmits(['zoomIn', 'zoomOut'])

const props = defineProps({
    hidden: {
        type: Boolean,
        default: true
    },
    zoomValue: {
        type: Number,
        default: 1
    },
    theme: {
        type: String,
        default: 'light',
        validator: (value) => {
            return ['light', 'dark'].includes(value);
        }
    }
})

const zoomIn = () => {
    if (zoomConfig.value >= MAX_ZOOM_VALUE) {
        return;
    }
    emit('zoomIn');
    appEvents.emit('zoomIn');
}

const zoomOut = () => {
    if (zoomConfig.value <= MIN_ZOOM_VALUE) {
        return;
    }
    emit('zoomOut');
    appEvents.emit('zoomOut');
}

watch(() => props.zoomValue, (newValue) => {
    //zoomConfig.value = newValue;
    appEvents.emit('currentZoom', newValue);
})

onMounted(() => {
    //zoomConfig.value = props.zoomValue;
    zoomStore.state.zoom = zoomStore.state.zoom || props.zoomValue;
    appEvents.emit('currentZoom', zoomStore.state.zoom);
})

appEvents.on('currentZoom', (value) => {
    zoomStore.state.zoom = value;
    zoomConfig.value = value;
});
</script>